import { Stack } from '@mui/material';
import {
  retentionCardsFixture,
  retentionConversionTrendsFixture,
} from 'api/reports-service/fixtures/retention.fixture';
import RetentionConversion from './retention-conversion.component';
import RetentionDetailTable from './retention-detail-table.component';
import RetentionLtvCards from './retention-ltv-cards.component';
import {
  criticalVisitNumbers,
  toConversionFractions,
  withConversionFromSignup,
} from './retention.utils';

// The fixture is the BE wire shape (integer percents); normalize to fractions
// the way the live endpoint's `transformResponse` does, since the preview
// renders the fixture directly without a query.
const fractionVisits = toConversionFractions(retentionConversionTrendsFixture);
const visits = withConversionFromSignup(fractionVisits);
const criticalVisits = criticalVisitNumbers(fractionVisits);

/**
 * Static, fixture-backed render of the Retention tab — no queries, no fetch.
 * Shown blurred behind the Data Plus paywall so the locked state still looks
 * like a populated report. Reuses the real presentational components so the
 * preview can't drift from the live tab.
 */
const RetentionLockedPreview = () => (
  <Stack spacing={2} data-testid="GuestJourney.Retention.LockedPreview">
    <RetentionLtvCards cards={retentionCardsFixture} signUpRangeDays={90} />
    <RetentionConversion visits={visits} criticalVisits={criticalVisits} />
    <RetentionDetailTable visits={visits} />
  </Stack>
);

export default RetentionLockedPreview;
